import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    auth: [],
    breadcrumb: [],
    myFuncKey: [],
    user: "",
  },
  getters: {
    isAuth: (state) => (code, path) => {
      return state.myFuncKey.some((item) => item === code);
    },
  },
  mutations: {
    setBreadcrumb(state, data) {
      const type = Number(!data.isInfo);
      switch (type) {
        case 0: {
          //添加
          let sign = state.breadcrumb.find((item) => item.title == data.title);
          sign ? state.breadcrumb.pop() : state.breadcrumb.push(data);
          break;
        }
        case 1: //添加
          state.breadcrumb = [data];
          break;
        // default:
        //   state.breadcrumb.splice(index, 1)
      }
    },
    initFuncKey(state, payload) {
      state.myFuncKey = payload;
    },
    initUser(state, payload) {
      state.user = payload;
    },
  },
  actions: {},
  modules: {},
});
